import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import { Row } from 'react-bootstrap'
import styled from 'styled-components'
import {
  Link,
  Outlet,
  useLocation,
  useOutletContext
} from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  PAGE_SETTING_LEAVE_MAS,
  PAGE_SETTING_LEAVE_ORG
} from '../../../router/routes'

export default function SettingLeaveV2Page() {
  const { t } = useTranslation()
  const locaiton = useLocation()
  const pathname = locaiton.pathname
  const { orgRole } = useOutletContext()

  const getLinkQuery = (url) => {
    return `${url}`
  }

  const menu = [
    {
      label: t('hrms_setting_leave_master'),
      link: getLinkQuery(PAGE_SETTING_LEAVE_MAS)
    },
    {
      label: t('hrms_setting_leave_org'),
      link: getLinkQuery(PAGE_SETTING_LEAVE_ORG)
    }
  ]
  const chkIsSubMenu = (d) => {
    let path = getLinkQuery(pathname)
    return path === d.link
  }
  return (
    <Row>
      <NavTitle>
        <TextNavTitle>
          {t('hrms_setting_leave_topic')}
        </TextNavTitle>
      </NavTitle>
      <BoxImage
        className="d-flex mb-3 rounded-2  mb-3"
        style={{
          maxHeight: '53px',
          zIndex: 1000
        }}
      >
        {menu.map((m, i) => (
          <Link
            to={m.link}
            key={i}
            style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
            className={`p-2 text-reset text-decoration-none text-center ${chkIsSubMenu(m) ? 'bottom-active' : 'opacity-25'
              }`}
          >
            <span className="me-2">{m.icon}</span>
            <span className="menu-label" style={{ fontSize: 'clamp(13px, 2vw, 16px)', fontWeight: 400 }}>{m.label}</span>
          </Link>
        ))}
      </BoxImage>
      <div className="flex-grow-1 d-flex flex-column">
        <Outlet context={{ orgRole }} /> {/* page content */}
      </div>
    </Row>
  )
}

const BoxImage = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  .bottom-active {
    color: var(--comp-badge-color-background-primary) !important;

    .menu-label {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -10px;
        height: 3px;
        border-radius: 2px 2px 0 0;
        background-color: var(--comp-badge-color-background-primary);
      }
    }
  }
`